module.exports = __webpack_public_path__ + "img/img_lingqufuyli@2x.d4d9146d.png";